import { Nullable } from '@heidi-pay/heidi-common-fe/types';

const getQueryObjectFromString = (str: string) =>
  Object.fromEntries(new URLSearchParams(str));

export const createSearchParamsObject = (
  unencodedSearchParams?: Nullable<string>,
) =>
  unencodedSearchParams ? getQueryObjectFromString(unencodedSearchParams) : {};
